export const selectDriverPaymentsEnabled = store => !!store.payment?.adyenConnectedAccount?.driverPaymentsEnabled
